/* global axios */
import ApiClient from '../ApiClient';

// Desfechos do Playbook do assistente (Fase 3): CRUD aninhado em captain/assistants.
class PolarisOutcomes extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  get({ assistantId } = {}) {
    return axios.get(`${this.url}/${assistantId}/outcomes`);
  }

  create({ assistantId, ...params } = {}) {
    return axios.post(`${this.url}/${assistantId}/outcomes`, {
      outcome: params,
    });
  }

  update({ assistantId, id, ...params } = {}) {
    return axios.patch(`${this.url}/${assistantId}/outcomes/${id}`, {
      outcome: params,
    });
  }

  delete({ assistantId, id } = {}) {
    return axios.delete(`${this.url}/${assistantId}/outcomes/${id}`);
  }
}

export default new PolarisOutcomes();
